export enum WithdrawalClassType {
    FiveDays = 0,
    SixDays = 1,
    SevenDays = 2
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/enums/withdrawalClassType.ts